package nacholab.supplies.i18n

class EnglishStrings : Strings {
    override val code = "en"

    override val strings = hashMapOf(
        "appTitle" to "Nacholab's Supplies",

        "authenticate_gplay_getinon" to "GET IT ON",
        "authenticate_gplay_gplay" to "Google Play",
        "authenticate_instructions" to "Enter your email address. You'll get a code to access your supplies.",
        "authenticate_enter" to "Get in!",

        "verifycode_instructions" to "Enter the verification code we sent to your email address",

        "supplylist_name" to "Name",
        "supplylist_stock" to "Stock",
        "supplylist_location" to "Location",
        "supplylist_current" to "Current",
        "supplylist_required" to "Required",
        "supplylist_home" to "Home",
        "supplylist_market" to "Market",

        "addsupply_title" to "Add new supply",
        "addsupply_name" to "Name",
        "addsupply_homeLocation" to "Location at home",
        "addsupply_marketLocation" to "Location at market",
        "addsupply_stock" to "Stock",
        "addsupply_cancel" to "Cancel",
        "addsupply_save" to "Save",
    )

    override val months = arrayOf(
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    )
}